import { render } from "./powerMonitor.vue?vue&type=template&id=c8517552"
import script from "./powerMonitor.vue?vue&type=script&lang=js"
export * from "./powerMonitor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__